"use client";

import type { MouseEvent, ReactNode } from "react";

type ReturnToPreviousPageProps = {
	href: string;
	className?: string;
	children: ReactNode;
};

declare global {
	interface Window {
		TaawnAndroidBridge?: { goBackToApp: () => void };
	}
}

export default function ReturnToPreviousPage({ href, className, children }: ReturnToPreviousPageProps) {
	function handleClick(event: MouseEvent<HTMLAnchorElement>) {
		if (window.TaawnAndroidBridge) {
			event.preventDefault();
			window.TaawnAndroidBridge.goBackToApp();
		} else if (new URLSearchParams(window.location.search).get("returnTo") === "app") {
			event.preventDefault();
			const requestedPackage = new URLSearchParams(window.location.search).get("appPackage");
			const appPackage = requestedPackage === "com.taawn.mobile.debug"
				? requestedPackage
				: "com.taawn.mobile";
			const fallback = encodeURIComponent(new URL(href, window.location.origin).toString());
			window.location.assign(
				`intent://return#Intent;scheme=taawn;package=${appPackage};S.browser_fallback_url=${fallback};end`,
			);
		} else if (window.history.length > 1) {
			event.preventDefault();
			window.history.back();
		} else if (document.referrer) {
			try {
				const referrer = new URL(document.referrer);
				if (referrer.origin === window.location.origin) {
					event.preventDefault();
					window.location.assign(referrer.href);
				}
			} catch {
				// Keep the home link fallback for malformed referrers.
			}
		}
	}

	return <a href={href} className={className} onClick={handleClick}>{children}</a>;
}
